module.exports = __webpack_public_path__ + "static/img/progress_type2.63f35e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_type2.png
// module id = 2ZXv
// module chunks = 1